/** @format */

import Filter from '../../../interfaces/forms/Filter';

export const useFilterParseToArray = (filterProcess: Array<Filter>, updateState: boolean): Array<Filter> => {
    const newFilters: Array<Filter> = [];
    for (let i = 0; i < filterProcess.length; i++) {
        let value = filterProcess[i].value;
        if (Array.isArray(value)) {
            for (let j = 0; j < value.length; j++) {
                newFilters.push({ name: filterProcess[i].name + '[]', value: value[j] });
            }
        } else {
            newFilters.push(filterProcess[i]);
        }
    }
    return newFilters;
};

export const useFilterParseToArrayWithColumn = (filterProcess: Array<Filter>, allowedColumn: Array<string>): Array<Filter> => {
    const newFilters: Array<Filter> = [];

    for (let i = 0; i < filterProcess.length; i++) {
        const currentFilter = filterProcess[i];
        const value = currentFilter.value;

        if (allowedColumn.includes(currentFilter.name) && Array.isArray(value)) {
            for (let j = 0; j < value.length; j++) {
                newFilters.push({
                    name: currentFilter.name + '[]',
                    value: value[j]
                });
            }
        } else {
            newFilters.push(currentFilter);
        }
    }

    return newFilters;
};